// tslint:disable:max-line-length
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule, SETTINGS } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireRemoteConfigModule, SETTINGS as REMOTE_CONFIG_SETTINGS, DEFAULTS as REMOTE_CONFIG_DEFAULTS } from '@angular/fire/compat/remote-config';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { UnauthorizedComponent } from './pages/portal/unauthorized/unauthorized.component';
import { DashboardComponent } from './pages/portal/landing/dashboard/dashboard.component';
import { BotAnalyticsComponent } from './pages/portal/bot/bot-analytics/bot-analytics.component';
import { CorpDashboardComponent } from './pages/portal/corp/corp-dashboard/corp-dashboard.component';
import { HierarchyElementDashboardComponent } from './pages/portal/hierarchy-element/hierarchy-element-dashboard/hierarchy-element-dashboard.component';
import { TagInputModule } from 'ngx-chips';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { BotAdminComponent } from './pages/admin/bot-admin/bot-admin.component';
import { ProfileComponent } from './pages/portal/profile/profile.component';
import { BotSettingsComponent } from './pages/portal/bot/bot-settings/bot-settings.component';
import { CorpSettingsComponent } from './pages/portal/corp/corp-settings/corp-settings.component';
import { HeirarchyElementSettingsComponent } from './pages/portal/hierarchy-element/hierarchy-element-settings/hierarchy-element-settings.component';
import { BotGeneralInfoComponent } from './components/bot/bot-general-info/bot-general-info.component';
import { HierarachyElementGeneralInfoComponent } from './components/hierarchy-element/hierarchy-element-general-info/hierarchy-element-general-info.component';
import { NavbarComponent } from './components/layout/navbar/navbar.component';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { AddCorpModalComponent } from './components/modals/add-corp-modal/add-corp-modal.component';
import { AddUserModalComponent } from './pages/admin/users-admin/_components/add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from './pages/admin/users-admin/_components/edit-user-modal/edit-user-modal.component';
import { AddBotModalComponent } from './components/modals/add-bot-modal/add-bot-modal.component';
import { AddFacebookPageModalComponent } from './components/modals/add-facebook-page-modal/add-facebook-page-modal.component';
import { AvatarPickerModalComponent } from './components/modals/avatar-picker-modal/avatar-picker-modal.component';
import { CorpGeneralInfoComponent } from './components/corp/corp-general-info/corp-general-info.component';
import { EditableImageComponent } from './components/common/editable-image/editable-image.component';
import { ToastrModule } from 'ngx-toastr';
import { CorpSettingsAdminComponent } from './pages/admin/corp-admin/corp-settings-admin/corp-settings-admin.component';
import { CorpsAdminComponent } from './pages/admin/corp-admin/corps-admin/corps-admin.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ProfileGeneralInfoComponent } from './components/profile/profile-general-info/profile-general-info.component';
import { AdminProfileComponent } from './pages/admin/admin-profile/admin-profile.component';
import { UsersAdminComponent } from './pages/admin/users-admin/users-admin/users-admin.component';
import { AddRoleModalComponent } from './pages/admin/roles-admin/_components/add-role-modal/add-role-modal.component';
import { RolesAdminComponent } from './pages/admin/roles-admin/roles-admin.component';
import { EditRoleModalComponent } from './pages/admin/roles-admin/_components/edit-role-modal/edit-role-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManageUserAssociationsComponent } from './pages/admin/users-admin/_components/manage-user-associations-modal/manage-user-associations-modal.component';
import { CorpHierarchiesAdminComponent } from './pages/admin/corp-admin/corp-hierarchies-admin/corp-hierarchies-admin.component';
import { AddCorpHierarchyModalComponent } from './pages/admin/corp-admin/corp-hierarchies-admin/_components/add-corp-hierarchy-modal/add-corp-hierarchy-modal.component';
import { EditCorpHierarchyModalComponent } from './pages/admin/corp-admin/corp-hierarchies-admin/_components/edit-corp-hierarchy-modal/edit-corp-hierarchy-modal.component';
import { AddHierarchyElementModalComponent } from './components/modals/add-hierarchy-element-modal/add-hierarchy-element-modal.component';
import { EditHierarchyElementModalComponent } from './pages/admin/hierarchies-admin/hierarchy-elements-admin/_components/edit-hierarchy-element-modal/edit-hierarchy-element-modal.component';
import { HierarchyElementsAdminComponent } from './pages/admin/hierarchies-admin/hierarchy-elements-admin/hierarchy-elements-admin.component';
import { HierarchyElementBotsAdminComponent } from './pages/admin/hierarchies-admin/hierarchy-element-bots-admin/hierarchy-element-bots-admin.component';
import { EngagementReportComponent } from './components/analytics/reports/engagement-report/engagement-report.component';
import { OverviewReportComponent } from './components/analytics/reports/overview-report/overview-report.component';
import { RepairOrderReportComponent } from './components/analytics/reports/repair-order-report/repair-order-report.component';
import { RepPerformanceReportComponent } from './components/analytics/reports/rep-performance-report/rep-performance-report.component';
import { IntentReportComponent } from './components/analytics/reports/intent-report/intent-report.component';
import { ReportContainerComponent } from './components/analytics/reports/report-container.component';

import { RecentConversationsComponent } from './components/analytics/conversations/recent-conversations/recent-conversations.component';
import { EnvironmentManagementModalComponent } from './components/modals/environment-management-modal/environment-management-modal.component';
import { UniqueBotNameValidatorDirective } from './shared/unique-bot-name.directive';
import { AddTeaserQRBModalComponentComponent } from './components/modals/add-teaser-qrbmodal-component/add-teaser-qrbmodal-component.component';
import { SingleItemDeleteConfirmationModalComponent } from './components/modals/single-item-delete-confirmation-modal/single-item-delete-confirmation-modal.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HlConversationTagsComponent } from './components/human-in-the-loop/hl-conversation-tags/hl-conversation-tags.component';
import { HlConversationTemplatesComponent } from './components/human-in-the-loop/hl-conversation-templates/hl-conversation-templates.component';
import { HlCustomerSettingsModalComponent } from './components/human-in-the-loop/hl-customer-settings-modal/hl-customer-settings-modal.component';
import { BotExportComponent } from './pages/portal/bot/bot-export/bot-export.component';
import { HlConversationAssignUserModalComponent } from './components/human-in-the-loop/hl-conversation-assign-user-modal/hl-conversation-assign-user-modal.component';
import { UserNotificationsComponent } from './components/notifications/user-notifications/user-notifications.component';
import { OverviewChartsComponent } from './components/analytics/overview-charts/overview-charts.component';
import { AnalyticsCardButtonComponent } from './components/analytics/analytics-cards/analytics-card-button/analytics-card-button.component';
import { AnalyticsChartComponent } from './components/analytics/analytics-chart/analytics-chart.component';
import { HlContainerComponent } from './components/_human-in-the-loop/hl-container/hl-container.component';
import { HlConversationListComponent } from './components/_human-in-the-loop/hl-conversation-list/hl-conversation-list.component';
import { HlMessagesListComponent } from './components/_human-in-the-loop/hl-messages-list/hl-messages-list.component';
import { HlMetaDataListComponent } from './components/_human-in-the-loop/hl-meta-data-list/hl-meta-data-list.component';
import { ScrollableDirective } from './shared/scrollable.directive';
import { HlActivityListComponent } from './components/_human-in-the-loop/hl-activity-list/hl-activity-list.component';
import { UniqueMessagesPipe } from './pipes/unique-messages.pipe';
import { HlSafeMessagePipe } from './pipes/hl-safe-message.pipe';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CdkTableModule } from '@angular/cdk/table';
import { BotUploadCampaignsComponent } from './pages/portal/bot/bot-upload-campaigns/bot-upload-campaigns.component';
import { AuthModule as Auth0Module } from '@auth0/auth0-angular';
import { AuthModule } from './modules/auth/auth.module';
import { AUTH_USE_AUTH0 } from './modules/auth/auth-use-auth0.injection-token';
import { CreateCampaignComponent } from './components/multi-list/create-campaign/create-campaign.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpansionPanelComponent } from './components/common/expansion-panel/expansion-panel.component';
import { CampaignOptionExpansionPanelComponent } from './components/multi-list/campaign-option-expansion-panel/campaign-option-expansion-panel.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CampaignOptionComponent } from './components/multi-list/campaign-option/campaign-option.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CancelConfirmModalComponent } from './components/modals/cancel-confirm-modal/cancel-confirm-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TopbarComponent } from './components/layout/topbar/topbar.component';
import { DashboardCardComponent } from './components/cards/dashboard-card/dashboard-card.component';
import { BotKnowledgeBankComponent } from './pages/portal/bot/bot-knowledge-bank/bot-knowledge-bank.component';
import { PriorityDashboardPage } from './pages/portal/voice-ai/pages/priority-dashboard/priority-dashboard.page';
import { DashboardTableComponent } from './pages/portal/voice-ai/components/dashboard-table/dashboard-table.component';
import { BotConfigCoreModule } from './modules/bot-config-core';
import { VoiceAiModule } from './modules/voice-ai';
import { NavigationModule } from './modules/navigation';
import { SharedModule } from './modules/shared/shared.module';
import { DASHBOARD_PREFERENCES_TTL } from './modules/voice-ai/dashboard-preferences/dashboard-preferences-ttl.injection-token';
import { ANALYTICS_WEBSOCKET_URL } from './modules/voice-ai/dashboard-websocket/analytics-websocket-url.injection-token';
import { URL_RESOLVER_STRATEGIES } from './modules/url-resolver/url-resolver-strategies.injection-token';
import { FIREBASE_AUTH_BASE_URLS } from './modules/firebase/firebase-auth-base-urls.injection-token';
import { FirebaseAuthInterceptor } from './modules/firebase/firebase-auth.interceptor';
import { S3_STORAGE_BASE_URL } from './modules/url-resolver/s3-storage-base-url.injection-token';
import { FirebaseUrlPipe } from './modules/firebase/firebase-url.pipe';
import { S3UrlResolverPipe } from './modules/url-resolver/s3-url-resolver.pipe';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    AdminLayoutComponent,
    BotAnalyticsComponent,
    BreadcrumbComponent,
    UnauthorizedComponent,
    DashboardComponent,
    HierarchyElementDashboardComponent,
    CorpDashboardComponent,
    CorpsAdminComponent,
    UsersAdminComponent,
    CorpSettingsAdminComponent,
    CorpHierarchiesAdminComponent,
    HierarchyElementsAdminComponent,
    AdminLayoutComponent,
    BasicLayoutComponent,
    AddCorpModalComponent,
    AddUserModalComponent,
    EditUserModalComponent,
    AddBotModalComponent,
    AddRoleModalComponent,
    EditRoleModalComponent,
    SingleItemDeleteConfirmationModalComponent,
    AddCorpHierarchyModalComponent,
    EditCorpHierarchyModalComponent,
    AddHierarchyElementModalComponent,
    EditHierarchyElementModalComponent,
    AddFacebookPageModalComponent,
    BotAdminComponent,
    ProfileComponent,
    AvatarPickerModalComponent,
    CorpGeneralInfoComponent,
    BotGeneralInfoComponent,
    EditableImageComponent,
    BotSettingsComponent,
    BotExportComponent,
    CorpSettingsComponent,
    HeirarchyElementSettingsComponent,
    ProfileGeneralInfoComponent,
    AdminProfileComponent,
    ManageUserAssociationsComponent,
    RolesAdminComponent,
    HierarachyElementGeneralInfoComponent,
    HierarchyElementBotsAdminComponent,
    RecentConversationsComponent,
    EngagementReportComponent,
    OverviewReportComponent,
    RepairOrderReportComponent,
    RepPerformanceReportComponent,
    IntentReportComponent,
    ReportContainerComponent,
    EnvironmentManagementModalComponent,
    BotKnowledgeBankComponent,
    UniqueBotNameValidatorDirective,
    AddTeaserQRBModalComponentComponent,
    HlConversationTagsComponent,
    HlConversationTemplatesComponent,
    HlCustomerSettingsModalComponent,
    HlConversationAssignUserModalComponent,
    UserNotificationsComponent,
    OverviewChartsComponent,
    AnalyticsCardButtonComponent,
    AnalyticsChartComponent,
    HlContainerComponent,
    HlConversationListComponent,
    HlMessagesListComponent,
    HlMetaDataListComponent,
    ScrollableDirective,
    HlActivityListComponent,
    UniqueMessagesPipe,
    HlSafeMessagePipe,
    BotUploadCampaignsComponent,
    CreateCampaignComponent,
    // TODO: do we have to have the base common component included here?
    ExpansionPanelComponent,
    CampaignOptionExpansionPanelComponent,
    CampaignOptionComponent,
    CancelConfirmModalComponent,
    TopbarComponent,
    DashboardCardComponent,
    PriorityDashboardPage,
    DashboardTableComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MonacoEditorModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireRemoteConfigModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    AuthModule,
    Auth0Module.forRoot({
      domain: environment.authSecrets.domain,
      clientId: environment.authSecrets.clientId,
      authorizationParams: {
        redirect_uri: environment.authSecrets.loginUrl,
      },
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ProgressbarModule.forRoot(),
    TagInputModule,
    SharedModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PaginationModule.forRoot(),
    AccordionModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    PopoverModule.forRoot(),
    CollapseModule,
    NgSelectModule,
    BsDatepickerModule,
    TooltipModule.forRoot(),
    AngularEditorModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    CdkTableModule,
    MatStepperModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    BotConfigCoreModule,
    SharedModule,
    VoiceAiModule,
    NavigationModule,
  ],
  /** providers set here should be the ones derived from environment or other global settings */
  providers: [
    { provide: AUTH_USE_AUTH0, useValue: environment.useAuth0 ?? false },
    { provide: SETTINGS, useValue: { ignoreUndefinedProperties: true } },
    { provide: REMOTE_CONFIG_SETTINGS, useValue: { minimumFetchIntervalMillis: 60000, fetchTimeoutMillis: 25000 } },
    { provide: REMOTE_CONFIG_DEFAULTS, useValue: { workListCountsFeatureFlag: false } },
    { provide: DASHBOARD_PREFERENCES_TTL, useValue: environment.voiceAiDashboardFiltersTTL },
    { provide: ANALYTICS_WEBSOCKET_URL, useValue: environment.analyticsWebSocket?.url ?? '' },
    FirebaseUrlPipe,
    S3UrlResolverPipe,
    { provide: URL_RESOLVER_STRATEGIES, useExisting: FirebaseUrlPipe, multi: true },
    { provide: URL_RESOLVER_STRATEGIES, useExisting: S3UrlResolverPipe, multi: true },
    { provide: S3_STORAGE_BASE_URL, useValue: environment.platformApi.url },
    { provide: FIREBASE_AUTH_BASE_URLS, useValue: [environment.platformApi.url, environment.dumbledore.url, environment.botConfig.url] },
    { provide: HTTP_INTERCEPTORS, useClass: FirebaseAuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
